
/*
  FIONA FRANCHIMON
  Mobile Sticky Purchase Buttons

  Uses the existing Shopify product form.

  Sticky is shown ONLY while the natural
  purchase buttons are further down the page.

  Once reached, the buttons return to
  their natural position and remain there
  while scrolling further down.
*/

(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const initialized = new WeakSet();

  function initializeHairpinSticky() {

    document.querySelectorAll(
      '.hairpin-pack-picker'
    ).forEach((picker) => {

      const productInfo = picker.closest(
        '.product__info-container'
      );

      if (!productInfo) return;

      // Exclude Quick Add
      if (productInfo.closest(
        'quick-add-modal, .quick-add-modal'
      )) return;

      const buttons = productInfo.querySelector(
        'product-form form[data-type="add-to-cart-form"] .product-form__buttons'
      );

      if (!buttons) return;
      if (initialized.has(buttons)) return;

      initialized.add(buttons);

      // Remember the natural button position
      const anchor = document.createElement('span');
      anchor.className = 'hairpin-sticky-anchor';
      anchor.setAttribute('aria-hidden', 'true');

      // Prevent layout jumping
      const spacer = document.createElement('div');
      spacer.className = 'hairpin-sticky-spacer';
      spacer.setAttribute('aria-hidden', 'true');

      buttons.before(anchor, spacer);

      let isSticky = false;
      let naturalHeight = buttons.offsetHeight;
      let frame = 0;

      function updateSticky() {

        if (!buttons.isConnected) return;

        if (!isSticky) {
          naturalHeight = buttons.offsetHeight;
        }

        const anchorTop =
          anchor.getBoundingClientRect().top;

        const threshold =
          window.innerHeight -
          Math.min(160, Math.max(60, naturalHeight));

        // Sticky only BEFORE reaching normal buttons
        const shouldStick =
          mobile.matches &&
          anchorTop > threshold;

        if (shouldStick === isSticky) return;

        if (shouldStick) {

          spacer.style.height =
            Math.ceil(naturalHeight) + 'px';

          productInfo.classList.add(
            'hairpin-sticky-on'
          );

        } else {

          productInfo.classList.remove(
            'hairpin-sticky-on'
          );

          spacer.style.height = '0px';

        }

        isSticky = shouldStick;
      }

      function scheduleUpdate() {

        if (frame) return;

        frame = requestAnimationFrame(() => {
          frame = 0;
          updateSticky();
        });
      }

      window.addEventListener(
        'scroll',
        scheduleUpdate,
        { passive: true }
      );

      window.addEventListener(
        'resize',
        scheduleUpdate
      );

      mobile.addEventListener(
        'change',
        scheduleUpdate
      );

      // Shopify's payment button may load later
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(
          scheduleUpdate
        );
        observer.observe(buttons);
      }

      scheduleUpdate();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeHairpinSticky
    );
  } else {
    initializeHairpinSticky();
  }

  // Shopify theme editor
  document.addEventListener(
    'shopify:section:load',
    initializeHairpinSticky
  );

})();
